export default __webpack_public_path__ + "static/media/add.dd08ccdb.svg";